// src/components/redesign/RedesignFrame.tsx
// The frame every page of the redesign sits in (WU-141 S-5, S-6). It does two things and nothing else:
//   1. mounts the animated background once, behind everything — the designer's App.tsx mounts ClassicLensBackground at its root for
//      the whole app; here the old onboarding flow keeps its own PageBackground, so the lens is mounted by this frame instead, and only
//      the routes nested under it see it;
//   2. carries the scoping root `ventaje-redesign` on <html> while it is mounted — every rule carved from the designer's index.css
//      (src/components/redesign/redesign.css) is written under that root, so no rule of the redesign reaches an old-flow element.
// Use it as a layout route: <Route element={<RedesignFrame />}> <Route path="..." element={<SomePage />} /> </Route>.
// The page content must be positioned (every designer page root is `position: relative`) to paint above the fixed lens layer.
import React, { useLayoutEffect } from 'react';
import { Outlet } from 'react-router-dom';
import ClassicLensBackground from '../dashboard/ClassicLensBackground';
import './redesign.css';

export const REDESIGN_ROOT_CLASS = 'ventaje-redesign';

const RedesignFrame: React.FC = () => {
  useLayoutEffect(() => {
    document.documentElement.classList.add(REDESIGN_ROOT_CLASS);
    return () => {
      document.documentElement.classList.remove(REDESIGN_ROOT_CLASS);
    };
  }, []);

  return (
    <div className="min-h-screen bg-transparent">
      <ClassicLensBackground />
      <Outlet />
    </div>
  );
};

export default RedesignFrame;
